// What the Clients page says after a bulk message (the "Individual" mode of the compose window).
//
// ⚠️ NOT EVERY SELECTED CLIENT IS WRITTEN TO. messages-bulk-send skips a client whose package has no
// messaging, and an id that is not this coach's client, and names them in its answer (in-app messaging
// audit, 2026-10-09, item 24). The words come from the server (_shared/bulk-send-summary.js) so this
// page and the coach app say the same thing; this only picks them out and flattens them to one line,
// because a toast shows one line.
//
// app.js's sendCompose calls this. It is a module, not more app.js, by the standing rule.

/**
 * @param {boolean} ok the response's res.ok
 * @param {any} json the response body
 * @returns {{ text: string, type: 'success'|'warning', sentSome: boolean } | null}
 *   null for a failure that is not a skip, which the caller reports as it always has
 */
export function bulkSendOutcome(ok, json) {
  const summary = json && json.summary;
  const skipped = json && Array.isArray(json.skipped) ? json.skipped.length : 0;
  const words = summary && typeof summary.title === 'string'
    ? `${summary.title}. ${String(summary.message || '').replace(/\s*\n+\s*/g, ' ')}`.trim()
    : null;
  if (!ok) {
    // Every selected client was skipped: nothing went, and the answer says who and why.
    return words && skipped ? { text: words, type: 'warning', sentSome: false } : null;
  }
  if (words && skipped) return { text: words, type: 'warning', sentSome: true };
  const n = json && typeof json.sent === 'number' ? json.sent : 0;
  return { text: `Message sent to ${n} client${n === 1 ? '' : 's'}.`, type: 'success', sentSome: true };
}
